import { render } from "./CartPayment.vue?vue&type=template&id=e23f3668"
import script from "./CartPayment.vue?vue&type=script&lang=js"
export * from "./CartPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__